<template>
  <div class="stats"></div>
</template>
<script>
  export default {
    name: 'Stats'
  }
</script>
<style scoped lang="scss" src="./Stats.scss"></style>
